import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import themes from './theme-map';

@Component({
  selector: 'cc-lg-theme-color',
  templateUrl: './theme-color.component.html',
  styleUrls: ['./theme-color.component.scss']
})
export class ThemeColorComponent implements OnInit {
  @Input() popupSettings: FormGroup;

  constructor() {}

  ngOnInit() {
    this.updateFontInputs(this.themeControl.value);
    this.themeControl.valueChanges.subscribe(themeName => {
      this.updateFontInputs(themeName);
    });
  }

  private get themeControl(): AbstractControl {
    return this.popupSettings.controls.theme;
  }

  private updateFontInputs(themeName: string) {
    const theme = themes[themeName];
    this.popupSettings.controls.customColor.setValue(theme.backgroundColor);
    this.popupSettings.controls.customFontColor.setValue(theme.fontColor);
  }
}
